import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class ClientGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(): boolean {
    let role = parseInt(localStorage.getItem('role'));
    // TODO: hardcoded role number, should have a shared lib
    if (role == 7 || role == 8 || role == 1 || role == 2) {
      return true;
    } else {
      this.router.navigateByUrl('/user');
    }
  }
}
